import { Inject, Injectable, InjectionToken } from '@angular/core';
import { BookingParametersInterface } from '../../shared/entities/bookingParameters';

export const SESSION_STORAGE = new InjectionToken<Storage>('Browser Storage', {
  providedIn: 'root',
  factory: () => (typeof window !== 'undefined') ? window.sessionStorage : null
});

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor(@Inject(SESSION_STORAGE) private sessionStorage) { }

  public write(key: string, val: string): boolean {
    try {
      this.sessionStorage.setItem(key, val);
      return true;
    } catch (error) {
      return false;
    }
  }

  public read(key: string): string | null {
    try {
      return this.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  public readBookingParameters(): BookingParametersInterface | null {
    try {
      const bookingParameters = JSON.parse(
        this.sessionStorage.getItem('bookingParameters')
      );
      return bookingParameters.bookingParameters;
    } catch (error) {
      return null;
    }
  }
}
